import { AxiosRequestConfig } from "axios";

export const postSignInAppleConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/oauth",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
